import { map, startWith, Observable, shareReplay } from 'rxjs';
import { loadMetaModel$ } from 'architectureModel/loadMetaModel';
import {
  LoadingState,
  LoadMetaModelAsScopedDataState,
} from './loadMetaModelTypes';
import { metaModelOperations } from 'architectureModel/metaModelOperations';

// TODO remove scope data from this stream
export const metaModelAsScopeData$: Observable<LoadMetaModelAsScopedDataState> =
  loadMetaModel$.pipe(
    map(metaModelOperations.processMetaModel),
    startWith({
      loading: 'loading the meta model...',
      status: 'LOADING',
    } satisfies LoadingState),
    shareReplay({ bufferSize: 1, refCount: true })
  );
